import { Component, forwardRef, Input } from '@angular/core';
import { BlockFactoryComponent } from '../block-factory/block-factory.component';

@Component({
  selector: 'app-block-list',
  templateUrl: './block-list.component.html',
  styleUrls: ['./block-list.component.scss'],
  imports: [forwardRef(() => BlockFactoryComponent)],
})
export class BlockListComponent {
  @Input() injectData = {};

  @Input() blockIdList: unknown[] = [];
}
